import "./AdminPageHeader.css";

import classNames from "classnames";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";

import { toggleBulkAssignColumns } from "shared/actions/admin/adminCasesActions";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";
import { ControlledToggleButton } from "components/customInputs/buttons/ToggleButton";
import DjangoLink from "components/DjangoLink";
import Header from "components/header/Header";
import ApplicationState from "store/ApplicationState";
import { useAppDispatch } from "store/hooks";

export type AdminPageHeaderProps = {
  navLinks?: { label: string; id: string; link: string }[];
  selectedLink?: string;
  logoLink?: string;
};

const AdminPageHeader = ({
  navLinks,
  selectedLink,
  logoLink,
}: AdminPageHeaderProps) => {
  const case_id = parseInt(useParams<{ case_id: string }>().case_id || "0");
  const features = useSelector(({ sys }: ApplicationState) => sys.features);
  const bulkAssignColumns = useSelector(
    ({ admin }: ApplicationState) => admin.cases.bulkAssignColumns
  );
  const dispatch = useAppDispatch();

  return (
    <Header
      displayProfile
      logoLink={logoLink || "/admin"}
      adminLink={
        <DjangoLink
          route={case_id ? `pathology/case/${case_id}/change/` : undefined}
          title={case_id ? "Django Case Access" : undefined}
        />
      }
    >
      {navLinks && (
        <nav className="AdminNav">
          {navLinks.map((val) => (
            <Link
              to={val.link}
              key={val.id}
              className={classNames("controls__button", {
                "controls__button--selected": val.id === selectedLink,
              })}
            >
              {val.label}
            </Link>
          ))}
          <div className="actions__container">
            {navLinks && selectedLink === "documents" && (
              <Link style={{ marginLeft: "auto" }} to="/admin/documents/upload">
                <PathologyWatchButton size="large" color="green">
                  Upload Document
                </PathologyWatchButton>
              </Link>
            )}
            {navLinks &&
              selectedLink === "cases" &&
              features?.bulkFinalizeSignature && (
                <div style={{ marginLeft: "auto" }}>
                  <ControlledToggleButton
                    size="large"
                    color="green"
                    isToggled={!!bulkAssignColumns}
                    onClick={() => dispatch(toggleBulkAssignColumns())}
                  >
                    Bulk Finalize Signature Columns
                  </ControlledToggleButton>
                </div>
              )}
          </div>
        </nav>
      )}
    </Header>
  );
};

export default AdminPageHeader;
